<template>
  <table class="table table-bordered">
    <tr>
      <td class="table-active"><i>x</i></td>
      <td v-for="(x, index) in values.x" :key="index">{{ x }}</td>
    </tr>
    <tr v-if="yFunction">
      <td class="table-active"><i>y</i></td>
      <td v-for="(x, index) in values.x" :key="index">{{ values.y(x) }}</td>
    </tr>
    <tr v-else>
      <td class="table-active"><i>y</i></td>
      <td v-for="(y, index) in values.y" :key="index">{{ y }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'FunctionTable',
  props: ['values'],
  computed: {
    yFunction: function () {
      return typeof this.values.y === 'function'
    }
  }
}
</script>

<style scoped>
i {
  font-family: 'Times New Roman';
  font-weight: bold;
}
table {
  width: auto !important;
  margin: 0 auto !important;
  outline: 1px solid black;
  font-size: 1.5rem;
}
th, td {
  padding: 0.2em 0.8em !important;
}
</style>



// WEBPACK FOOTER //
// src/math/elements/FunctionTable.vue